import { createCommonUtilsApi } from "../api-helpers/CommonUtilsApiHelper";
import { Lookup } from "../interfaces/allergy";
import { GridDropdown } from "./GridDropdown";

export interface Props {
  label: string;
  type: string;
  initialValues?: Lookup[];
  onChange: (selection: Lookup[]) => void;
}

export const GridLookupDropdown = ({ label, type, initialValues, onChange }: Props) => {
  const lookupApi = createCommonUtilsApi();

  const loadData = async (): Promise<Lookup[]> => {
    if (!type) {
      return [];
    }
    
    const response = await lookupApi.lookupControllerFindAll(type);
    return response.data;
  };

  return (
    <GridDropdown
      label={label}
      keyProvider={lookup => lookup.id}
      labelProvider={lookup => lookup.name}
      dataProvider={loadData}
      initialKeys={initialValues?.map(item => item.id)}
      onChange={onChange}
      ></GridDropdown>
  );
};
